import { tr as __tr, useLocale as __useLocale, direction as __direction, localizedField as __localizedField } from "../../i18n/runtime";
import React, { useState } from 'react';
import { Search } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { useCatalog, countryName, cityName } from '../../context/CatalogContext';
import { visaTypeLabel } from '../CatalogResults';
function CatalogSelect({
  label,
  value,
  onChange,
  options,
  disabled
}) {
  __useLocale();
  return <label className="space-y-2 block text-sm text-gray-600"><span>{__tr(label)}</span>
    <select value={value} onChange={e => onChange(e.target.value)} disabled={disabled} className="block w-full h-12 rounded-xl border border-gray-200 bg-white px-3">
      <option value="">{__tr("الكل")}</option>
      {__tr(options.map(option => <option key={option.value} value={option.value}>{__tr(option.label)}</option>))}
    </select>
  </label>;
}
const optionsFor = values => [...new Set(values.filter(Boolean))].map(value => ({
  value,
  label: value
}));
export default function CatalogSearchForm({
  kind
}) {
  __useLocale();
  const {
    hotels,
    visas,
    countries,
    cities,
    loading,
    error,
    setHotelFilter,
    setVisaFilter
  } = useCatalog();
  const isHotel = kind === 'hotel';
  const [country, setCountry] = useState('');
  const [city, setCity] = useState('');
  const [type, setType] = useState('');
  const [stars, setStars] = useState('');
  const [minPrice, setMinPrice] = useState('');
  const [maxPrice, setMaxPrice] = useState('');
  const items = isHotel ? hotels : visas;
  const countryOptions = optionsFor([...countries.filter(c => c.type === (isHotel ? 'country' : 'visa')).map(c => c.name), ...items.map(i => countryName(i.country, countries))]).map(o => ({
    ...o,
    label: __localizedField(countries.find(c => c.name === o.value || c.value === o.value), 'name') || o.label
  }));
  const cityOptions = optionsFor([...(country ? [] : cities.filter(c => !c.type || c.type === 'hotel').map(c => c.name)), ...hotels.filter(h => !country || countryName(h.country, countries) === country).map(h => cityName(h.city, cities))]).map(o => ({
    ...o,
    label: __localizedField(cities.find(c => c.name === o.value || c.code === o.value), 'name') || o.label
  }));
  const typeOptions = optionsFor(visas.filter(v => !country || countryName(v.country, countries) === country).map(v => v.visa_type)).map(o => ({
    ...o,
    label: visaTypeLabel(o.value)
  }));
  const invalidRange = isHotel && minPrice !== '' && maxPrice !== '' && Number(minPrice) > Number(maxPrice);
  return <form className="space-y-6" dir={__direction()} onSubmit={e => {
    e.preventDefault();
    if (invalidRange) return;
    if (isHotel) setHotelFilter({
      country,
      city,
      stars,
      minPrice,
      maxPrice
    });else setVisaFilter({
      country,
      type
    });
    document.getElementById(`${kind}-results`)?.scrollIntoView({
      behavior: 'smooth'
    });
  }}>
    <div className={`grid grid-cols-1 md:grid-cols-2 gap-4 ${isHotel ? 'lg:grid-cols-5' : 'max-w-2xl mx-auto'}`}>
      <CatalogSelect label={__tr("الدولة")} value={country} onChange={value => {
        setCountry(value);
        setCity('');
        setType('');
      }} options={countryOptions} disabled={loading || !!error} />
      {__tr(isHotel ? <>
        <CatalogSelect label={__tr("المدينة")} value={city} onChange={setCity} options={cityOptions} disabled={loading || !!error} />
        <CatalogSelect label={__tr("النجوم")} value={stars} onChange={setStars} options={[1, 2, 3, 4, 5].map(n => ({
          value: String(n),
          label: "" + n + __tr(" نجوم")
        }))} />
        <label className="space-y-2 text-sm text-gray-600">{__tr("السعر الأدنى")}<Input type="number" min="0" step="any" value={minPrice} onChange={e => setMinPrice(e.target.value)} className="h-12 rounded-xl" /></label>
        <label className="space-y-2 text-sm text-gray-600">{__tr("السعر الأقصى")}<Input type="number" min="0" step="any" value={maxPrice} onChange={e => setMaxPrice(e.target.value)} className="h-12 rounded-xl" /></label>
      </> : <CatalogSelect label={__tr("نوع التأشيرة")} value={type} onChange={setType} options={typeOptions} disabled={loading || !!error} />)}
    </div>
    {__tr(isHotel && <p className="text-sm text-gray-500">{__tr("الأسعار بالعملة الموضحة لكل فندق.")}</p>)}
    {__tr(invalidRange && <p role="alert" className="text-red-700">{__tr("يجب أن يكون السعر الأقصى أكبر من أو يساوي السعر الأدنى.")}</p>)}
    <div className="flex justify-center pt-4"><Button type="submit" disabled={loading || !!error || invalidRange} className="bg-[#6B5B95] hover:bg-[#5B4B85] text-white px-12 py-6 rounded-xl text-lg flex gap-2"><Search className="w-5 h-5" />{__tr(isHotel ? "بحث الفنادق" : "البحث عن تأشيرات")}</Button></div>
  </form>;
}
